import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './input.scss';

/**
 * Input component.
 */
const Input = React.forwardRef((props, ref) => {
    const [value, setValue] = useState('');

    /**
     * Handles input value changes.
     * @param {object} e Event tiggered.
     */
    function handleValueChange(e) {
        setValue(e.target.value.replace(/^\s/ig, ''));
    }

    return (
        <div className={styles.wrapper} style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
            <input
                ref={ref}
                className={'form-field'}
                autoFocus={props.autoFocus}
                type={props.type}
                name={props.name}
                disabled={props.disabled}
                value={props.value || value}
                onBlur={props.onBlur}
                onKeyDown={props.onKeyDown}
                onChange={props.onChange || handleValueChange}
                id={'input-field-' + props.name}
                placeholder={props.placeholder}
            />
        </div>
    );
});

Input.propTypes = {
    autoFocus: PropTypes.bool,
    /**
     * Input html name parameter.
     */
    name: PropTypes.string.isRequired,
    /**
     * Input html placeholder parameter.
     */
    placeholder: PropTypes.string,
    /**
     * Input html type parameter.
     */
    type: PropTypes.string.isRequired,
    /**
     * Calls on every value change.
     */
    onChange: PropTypes.func,
    /**
     * Calls on input field blur.
     */
    onBlur: PropTypes.func,
    /**
     * Calls on every key down inside input.
     */
    onKeyDown: PropTypes.func,
    /**
     * Current input value.
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * Disable input.
     */
    disabled: PropTypes.bool,
};

Input.defaultProps = {
    type: 'text',
    placeholder: '',
    required: false,
    disabled: false,
};

Input.displayName = 'Input';

export default Input;
